import { useRef } from 'react';
import { Link } from 'react-router-dom';
import { motion, useInView } from 'framer-motion';
import { Calendar, Tv, Users } from 'lucide-react';
import { WhatsAppButton } from '../WhatsAppButton';
import { useLanguage } from '../../context/LanguageContext';

export const About = () => {
  const { t } = useLanguage();
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-100px" });

  return (
    <section id="about" ref={ref} className="py-32 bg-white" data-testid="about-section">
      <div className="max-w-5xl mx-auto px-6 md:px-12">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
        >
          <p className="overline mb-4">{t.about.subtitle}</p>
          <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-slate-900 mb-8 tracking-tight">
            {t.about.title}
          </h2>
          <p className="text-xl text-slate-600 leading-relaxed mb-6">
            {t.about.description}
          </p>
          <p className="text-lg text-slate-600 leading-relaxed">
            {t.about.communityText}
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8, delay: 0.2, ease: [0.16, 1, 0.3, 1] }}
          className="flex flex-wrap gap-4 mt-10"
        >
          <a
            href="https://bookpadelarena.ch"
            target="_blank"
            rel="noopener noreferrer"
            className="athletic-button athletic-button-primary inline-flex items-center gap-2"
            data-testid="about-book-court-btn"
          >
            <Calendar className="w-5 h-5" />
            {t.about.bookCourtBtn}
          </a>
          <WhatsAppButton
            linkKey="community"
            className="athletic-button athletic-button-secondary inline-flex items-center gap-2"
            testId="about-join-community-btn"
          >
            <Users className="w-5 h-5" />
            {t.about.joinCommunityBtn}
          </WhatsAppButton>
          <Link
            to="/sports-bar"
            className="inline-flex items-center gap-3 px-10 py-4 rounded-xl font-bold text-sm uppercase tracking-wider border-2 border-slate-900 text-slate-900 bg-transparent hover:bg-slate-900 hover:text-white transition-all"
            data-testid="about-sports-bar-btn"
          >
            <Tv className="w-5 h-5" />
            {t.about.sportsBarBtn}
          </Link>
        </motion.div>
      </div>
    </section>
  );
};
